import type { RouteProps } from 'src/types/router';

import { ACCOUNT_ROUTE } from './account';
import { API_INTEGRATIONS_ROUTE } from './apiIntegrations';
import { AUTH_ROUTE } from './auth';
import { EMAIL_CHANGE_ROUTE } from './change-email';
import { PASSWORD_CHANGE_ROUTE } from './change-password';
import { CLEARVERIFY_STAFF_ROUTE } from './clearVerifyStaff';
import { DASHBOARD_ROUTE } from './dashboard';
import { EMAIL_TRACKER_ROUTE } from './emailTracker';
import { EMPLOYEES_ROUTE } from './employees';
import { EMPLOYER_STAFF_ROUTE } from './employerStaff';
import { EMPLOYERS_ROUTE } from './employers';
import { HOME_ROUTE } from './home';
import { INBOX_ROUTE } from './inbox';
import { MAINTENANCE_ROUTE } from './maintenance';
import { MY_DATA_ROUTE } from './my-data';
import { MY_VERIFY_ROUTE } from './my-verify';
import { NOT_FOUND_ROUTE } from './not-found';
import { PARTNERSHIPS_ROUTE } from './partnerships';
import { PEO_PAYROLL_PROVIDER_STAFF_ROUTE } from './peoPayrollProviderStaff';
import { PEO_PAYROLL_PROVIDERS_ROUTE } from './peoPayrollProviders';
import { PEO_STAFF_ROUTE } from './peoStaff';
import { PEOS_ROUTE } from './peos';
import { PERSIK_ROUTE } from './persik';
import { REPORTS_ROUTE } from './reports';
import { RESOURCES_ROUTE } from './resources';
import { VERIFIER_STAFF_ROUTE } from './verifierStaff';
import { VERIFIERS_ROUTE } from './verifiers';

export const ROUTES_TREE = [
  HOME_ROUTE,
  MAINTENANCE_ROUTE,
  AUTH_ROUTE,
  EMPLOYERS_ROUTE,
  VERIFIERS_ROUTE,
  ACCOUNT_ROUTE,
  CLEARVERIFY_STAFF_ROUTE,
  REPORTS_ROUTE,
  RESOURCES_ROUTE,
  EMAIL_CHANGE_ROUTE,
  EMPLOYER_STAFF_ROUTE,
  PEO_PAYROLL_PROVIDER_STAFF_ROUTE,
  VERIFIER_STAFF_ROUTE,
  PEO_STAFF_ROUTE,
  EMPLOYEES_ROUTE,
  MY_VERIFY_ROUTE,
  PASSWORD_CHANGE_ROUTE,
  INBOX_ROUTE,
  MY_DATA_ROUTE,
  PERSIK_ROUTE,
  EMAIL_TRACKER_ROUTE,
  API_INTEGRATIONS_ROUTE,
  NOT_FOUND_ROUTE,
  PARTNERSHIPS_ROUTE,
  PEOS_ROUTE,
  PEO_PAYROLL_PROVIDERS_ROUTE,
  DASHBOARD_ROUTE,
] as const satisfies RouteProps[];
